'use client';

import './globals.css';

import { Button, Stack, Typography } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { defaultConfig } from '@repo/api';
import { Component, ErrorInfo, PropsWithChildren, ReactNode } from 'react';

import HStack from '@/components/common/HStack';

import { AuthProvider } from '../providers/AuthProvider';
import { GlobalProvider } from '../providers/GlobalProvider';

class Boundary extends Component<
  { children: ReactNode },
  { error: Error | null; componentStack: string | null }
> {
  state = { error: null as Error | null, componentStack: null as string | null };

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Envoie vers ta télémétrie (Sentry/Datadog/console)
    // eslint-disable-next-line no-console -- ErrorBoundary is outside React tree; keep console for telemetry
    console.error(error, info.componentStack);
    this.setState({ error, componentStack: info.componentStack ?? null });
  }

  copyErrorAndComponentStack = () => {
    const { error, componentStack } = this.state;
    if (!error) return;
    navigator.clipboard.writeText(`${error.message}\n${componentStack}`);
  };

  render() {
    return this.state.error ? (
      <HStack justifyContent="center" height="100vh">
        <Stack alignItems="center" border={1} borderColor="red" p={2} borderRadius={1}>
          <Typography variant="body1" color="error">
            Une erreur est survenue, veuillez le signaler à l'équipe de développement en copiant le
            message d'erreur ci-dessous.
          </Typography>
          <Button
            onClick={this.copyErrorAndComponentStack}
            variant="contained"
            color="error"
            style={{ marginTop: '10px' }}
          >
            Copier le message d'erreur
          </Button>
        </Stack>
      </HStack>
    ) : (
      this.props.children
    );
  }
}

export default function RootLayout({ children }: PropsWithChildren) {
  return (
    <html lang="fr">
      <body>
        <CssBaseline />
        <GlobalProvider
          baseRoute="/"
          config={defaultConfig}
          customComponents={defaultConfig.customComponents}
        >
          <Boundary>
            <AuthProvider>{children}</AuthProvider>
          </Boundary>
        </GlobalProvider>
      </body>
    </html>
  );
}
